// src/hr/timeoff/WhosOutPage.js -- the month view of who's out, for everyone on HR's list.
import React from 'react';
import { Card } from '../kit';
import WhosOutCalendar from '../WhosOutCalendar';

export function WhosOutPage({ today }) {
  return (
    <div className="hrp-page">
      <div className="hrp-page-head">
        <div>
          <h1 className="hrp-h1">Who's out</h1>
          <p className="hrp-sub">Approved time off and sick days, Monday to Friday.</p>
        </div>
      </div>
      <Card delay={0} className="hrp-calcard">
        <WhosOutCalendar mode="month" today={today} />
      </Card>
    </div>
  );
}

export default WhosOutPage;
